export default __webpack_public_path__ + "static/media/LAS0980.34I-42143_-25476_0.5b9d7854.jpg";